function showBackInStockPopup(productId) {
  // Получаем данные о товаре через Shopify AJAX API
  fetch(`/products/${productId}.js`)
    .then(response => response.json())
    .then(product => {
      // Заполняем поп-ап
      document.getElementById('popup-product-image').src = product.featured_image;
      document.getElementById('popup-product-title').innerText = product.title;
      const variantSelect = document.getElementById('popup-variant-select');
      variantSelect.innerHTML = '';
      product.variants.forEach(variant => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.text = variant.title;
        variantSelect.appendChild(option);
      });

      // Показываем поп-ап
      document.getElementById('back-in-stock-popup').style.display = 'block';
      document.getElementById('popup-overlay').style.display = 'block';
    });
}

function closePopup() {
  document.getElementById('back-in-stock-popup').style.display = 'none';
  document.getElementById('popup-overlay').style.display = 'none';
}

function subscribeToBackInStock() {
  const email = document.getElementById('popup-email').value;
  const variantId = document.getElementById('popup-variant-select').value;

  if (!email) {
    alert('Please enter your email');
    return;
  }

  // Отправка в Klaviyo через API
  fetch('https://a.klaviyo.com/api/v2/list/<RESTOCK>/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Klaviyo-API-Key <TYNEaP>'
    },
    body: JSON.stringify({
      profiles: [{
        email: email,
        properties: {
          variant_id: variantId,
          source: 'Back in Stock'
        }
      }]
    })
  })
  .then(response => {
    if (response.ok) {
      alert('Subscribed successfully!');
      closePopup();
    } else {
      alert('Error subscribing. Please try again.');
    }
  });
}